import { registerBrick } from 'olympe';
import {ReactBrick, useMUITheme, updateNavigationState} from "@olympeio/core";
import React from "react";
import { Card, CardContent } from "@mui/material";
import { LineChart } from "lucide-react";
import { ThemeProvider } from '@mui/material/styles';


export default class AnalysisHomeSwitch extends ReactBrick {

    /**
     * @override
     */
    static getReactComponent($) {
        return () => {
            const theme = useMUITheme($);
            return (
                <ThemeProvider theme={theme}>
                    <div className="h-full w-full bg-indigo-50 flex flex-col items-center p-6 overflow-y-auto">
                        {/* Header */}
                        <header className="w-full max-w-4xl text-center py-6">
                            <h1 className="text-4xl font-bold text-indigo-700">Choix de la stratégie</h1>
                            <br /><br />
                            <p className="mt-2 text-gray-600">
                                Visualisez les résultats des stratégies proposées sur différentes cryptomonnaies pour les années passées.
                            </p>
                        </header>

                        {/* Strategies Section */}
                        <section className="w-full max-w-4xl grid md:grid-cols-2 gap-4 my-4">
                            <Card className="relative cursor-pointer " onClick={() => updateNavigationState('/analysis/range')}>
                                <CardContent className="p-6">
                                    <h2 className="text-2xl font-semibold text-indigo-700">Stratégie Prudente</h2>
                                    <p className="text-gray-600 mt-2">
                                        Une approche sécurisée offrant un rendement stable et constant. Idéale pour les investisseurs long-terme et prudents.
                                    </p>
                                    <p className="text-green-600 mt-2 font-bold">Rendement sur la moyenne des 5 dernières années : 7-10% par an</p>
                                    <br /><br />
                                    <div className="absolute bottom-4 right-4 flex items-center text-indigo-700 cursor-pointer">
                                        <LineChart className="w-6 h-6 mr-2" />
                                        <span className="font-semibold">Lancer le simulateur</span>
                                    </div>
                                </CardContent>
                            </Card>

                            <Card className="relative cursor-pointer" onClick={() => updateNavigationState('/analysis/trend')}>
                                <CardContent className="p-6">
                                    <h2 className="text-2xl font-semibold text-indigo-700">Stratégie Dynamique</h2>
                                    <p className="text-gray-600 mt-2">
                                        Une méthode plus agressive avec des gains plus élevés, pour ceux prêts à prendre plus de risques.
                                    </p>
                                    <p className="text-green-600 mt-2 font-bold">Rendement sur la moyenne des 5 dernières années : 15 à 210% par an selon les paires</p>
                                    <br /><br />
                                    <div className="absolute bottom-4 right-4 flex items-center text-indigo-700 cursor-pointer">
                                        <LineChart className="w-6 h-6 mr-2" />
                                        <span className="font-semibold">Lancer le simulateur</span>
                                    </div>
                                </CardContent>
                            </Card>
                        </section>

                        {/* Disclaimer */}
                        <footer className="w-full max-w-4xl mt-12 p-4 border-t border-gray-300 text-center text-sm text-gray-500">
                            <p>
                                Avertissement : Le trading comporte des risques de pertes. Aucune performance passée ne garantit des résultats futurs.
                                Investissez uniquement ce que vous pouvez vous permettre de perdre.
                            </p>
                        </footer>
                    </div>
                </ThemeProvider>
            );
        }
    }
}

registerBrick('01959574dfe3543edfc4', AnalysisHomeSwitch);
